import { useNavigate, useParams } from 'react-router-dom'
import { saveTraveller, useTraveller } from './Functions'
import { Button, Flex, Input, Spinner, Text } from '../../../../Components'
import { useCQuery } from '../../../../Services'

const defaultStyle = { width: '31%', marginRight: '1%', marginLeft: '1%', marginBottom: 15 }
const fields = {
  pid: { label: 'PID' },
  email: { label: 'Email' },
  phone: { label: 'Telefono' }
}

export function TravellerEditor () {
  const { travellerId } = useParams()
  const navigate = useNavigate()
  const [traveller, setTraveller, isSuccess] = useTraveller(travellerId)
  const { id = '', environmentId } = traveller || {}
  const { data: environments = [] } = useCQuery(['environments'])

  const save = async () => {
    const res = await saveTraveller(traveller)
    res?.id && navigate('/admin/travellers/' + res?.id?.toString())
    return res
  }

  if (!isSuccess || !traveller) return <Spinner />

  const isNew = id === 'new'

  return (
    <Flex fw>
      <Text value={`${isNew ? 'Crea' : 'Modifica'} Viaggiatore`} title bold size={30} />
      <Flex fw row wrap style={{ marginTop: 20 }}>
        {Object.keys(fields).map((key) =>
          <Input key={key} value={traveller[key]} onChange={({ [key]: value }) => setTraveller(key, value)} label={fields[key]?.label} id={key} style={{ ...defaultStyle }} />
        )}
        <Input
          value={environmentId} dropdown options={environments.map(({ id, name }) => ({ value: id, label: name }))}
          onChange={({ environmentId: value }) => setTraveller('environmentId', value)}
          label='Società' id='environmentId' style={{ ...defaultStyle }}
        />
        <Flex fw row style={{ marginTop: 20 }}>
          <Button label='Salva' icon='fa-duotone fa-floppy-disk' style={{ marginRight: 10 }} onClick={save} />
          <Button label='Torna indietro' icon='fa-duotone fa-arrow-left' onClick={() => navigate('/admin/travellers/list')} />
        </Flex>
      </Flex>
    </Flex>
  )
}
